import styled, { AnyStyledComponent } from 'styled-components';

import {
    ContentCardOrientations,
    ContentCardProps,
    ContentCardImageWrapperProps ,
} from './contentCard.types';

import IconDefault from '../Icon/icon';
import ImageDefault from '../Image/image';

import { MLBTheme } from '../../style/theme.types';
import FONTS from '../../style/fonts';
import COLORS from '../../style/universal.color';
import BREAKPOINTS from '../../style/breakpoints';

const { LANDSCAPE, PORTRAIT } = ContentCardOrientations;

const retrieveColorTheme = (theme:  MLBTheme): string => {
    const { dark, teamColor1 } = theme;
    return teamColor1 || (dark ? 'white' : 'black');;
}

export const ContentCardWrapper: AnyStyledComponent = styled.div`
    color: ${({theme}) => retrieveColorTheme(theme) };
    display: flex;
    flex-direction: ${({orientation}: ContentCardProps) => orientation === LANDSCAPE ?  'row' : 'column'};
    font-family: ${FONTS.primaryFont};
    height: ${({isLoading}: ContentCardProps) => isLoading ? '100%' : 'auto'};
`;

export const ContentWrapper: AnyStyledComponent = styled.div`
    margin-left: ${({orientation}: ContentCardProps) => orientation === PORTRAIT ?  '0' : '10px'};
    padding-top: 5px;
    width: 100%;
    p {
        color: ${COLORS.mlbGrey4};
        font-size: 11px;
        margin: 2px 0 0 0;
    }
`;

export const TitleWrapper: AnyStyledComponent = styled.div`
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.2px;
    span {
        color: ${({videoProps}: ContentCardProps) => videoProps && videoProps.callOutTextProps && videoProps.callOutTextProps.color || COLORS.liveYellow};
        display: ${({videoProps}: ContentCardProps) => videoProps && videoProps.callOutTextProps ? 'inline': 'none'};
        font-weight: bold;
        font-size: 13px;
        letting-spacing: normal;
        text-transform: uppercase;
    };
    span::before {
        content: "•";
    }

`;

export const ImageWrapper: AnyStyledComponent = styled.div`
    flex-grow: ${({isLoading}: ContentCardImageWrapperProps) => isLoading ? 1 : 'initial'};
    line-height: 0;
    position: relative;
    align-self: ${({fixAspect}: ContentCardImageWrapperProps) => fixAspect ? 'flex-start': 'initial'};
    width:  ${({imageProps, orientation}: ContentCardImageWrapperProps) => orientation === LANDSCAPE && imageProps.width ? imageProps.width : '100%'};

    ${({isActive, isActiveText, imageProps}: ContentCardImageWrapperProps) => {
        if(isActive) {
            return `
                ::after {
                    align-items: center;
                    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.5));
                    border: solid 2px ${COLORS.linkBlue};
                    border-radius: ${imageProps.borderRadius};
                    box-sizing: border-box;
                    color: #fff;
                    content: "${isActiveText}";
                    display: flex;
                    font-size: 11px;
                    font-weight: bold;
                    height: 100%;
                    justify-content: center;
                    left: 0;
                    position: absolute;
                    top: 0;
                    width: 100%;
                    @media only screen and (min-width: ${BREAKPOINTS.md}) {
                        font-size: 13px;
                    }
                }
            `
        }
        return '';
    }};
`;

export const TimePill: AnyStyledComponent = styled.p`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,.6);
    border-radius: 25px;
    box-sizing: border-box;
    color: ${COLORS.mlbWhite};
    font-size: 11px;
    font-weight: 500;
    line-height: 18px;
    margin-bottom: 0;
    min-width: 44px;
    padding: 0 8px;
    position: absolute;
    right: 6px;
    bottom: 6px;
    ${({isActive}: ContentCardProps) => isActive ? 'display:none;' : ''}
`;

export const DataWrapper: AnyStyledComponent = styled.div`
    display: flex;
    position: relative;
    justify-content: space-between;
`;

export const Metadata: AnyStyledComponent = styled.div`
`;

export const Icon: AnyStyledComponent = styled(IconDefault)`
    background: rgba(255, 255, 255, 0.8);
    border-radius: 100px;
    bottom: 5px;
    left: 6px;
    position: absolute;
    ${({isActive}: ContentCardImageWrapperProps) => isActive ? 'display:none;' : ''}
`;


export const Image: AnyStyledComponent = styled(ImageDefault)`
    padding: 0;
    height: 100%;
`;
